/**
 * @author Hiroki Moto
 * @description https://marvelapp.com/4g4b5dg/screen/55348072
 */

import React from 'react';
import PropTypes from 'prop-types';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import isNil from 'ramda/src/isNil';
import isEmpty from 'ramda/src/isEmpty';
import length from 'ramda/src/length';
import loadable from '@loadable/component';
import moment from 'moment';
import Accordion from '@components/@core/Accordion';
import Filter from '@components/@core/Filter';
import Settings from '@components/@core/Settings';
import find from 'ramda/src/find';
import propEq from 'ramda/src/propEq';
import EditDropdown from '@components/EditDropdown';
import { LibraryToDoScorecardMenu, ScoreCardTypes } from '~/services/config';
import Quota from './Quota';

class Detail extends React.PureComponent {
    state = { quotas: [] };

    static getDerivedStateFromProps(nextProps, prevState) {
        const { data } = nextProps;
        if (!isNil(data.data)) {
            if (length(data.data.quotas) > 0) {
                const quota = data.data.quotas[0];
                if (!isNil(quota.data)) {
                    const quotas = data.data.quotas;
                    return { quotas };
                }
            }
        }
        return null;
    }

    render() {
        const { data, authors, departments, competencies, categories, userRole, onSelect } = this.props;
        const { quotas } = this.state;

        if (isNil(data) || isEmpty(data)) return null;

        const scorecardType = find(propEq('id', data.type ?? 0), ScoreCardTypes);
        const author = find(propEq('id', data.author_id ?? 0), authors);
        const department = (data.data?.department ?? []).map((e) => {
            const _department = find(propEq('id', e), departments);
            return _department?.name ?? '';
        });
        const competency = (data.data?.competency ?? []).map((e) => {
            const _competency = find(propEq('id', e), competencies);
            return _competency?.name ?? '';
        });
        const category = (data.data?.category ?? []).map((e) => {
            const _category = find(propEq('id', e), categories);
            return _category?.name ?? '';
        });
        const dropDown = LibraryToDoScorecardMenu[userRole].filter((el) => el !== 'Detail View');

        const settings = [
            { name: 'Author', id: [data.author_id], options: authors },
            { name: 'Departments', id: data.data?.department, options: departments },
            { name: 'Competencies', id: data.data?.competency, options: competencies },
            { name: 'Categories', id: data.data?.category, options: categories },
        ];
        const stats = [
            { name: 'Created', value: moment(data?.created_at).format('MMM DD, YY') || null },
            { name: 'Created By', value: data?.created_by || 'Na' },
            { name: 'Last Edited', value: moment(data?.updated_at).format('MMM DD, YY') || null },
            { name: 'Last edits by', value: data?.edited_by || 'Na' },
            { name: 'Assigned', value: data?.assigned || 'Na' },
        ];

        return (
            <>
                <Filter back="all scorecards" />
                <div className="lib-todo-scorecard" data-cy="scorecardDetail">
                    <div className="scorecard-detail">
                        <div className="section">
                            <div className="d-h-between mb-4">
                                <p className="dsl-b18 bold mb-0">Scorecard</p>
                                <div className="d-h-end">
                                    <EditDropdown dataCy="scorecardEditDropdown" options={dropDown} onChange={(e) => onSelect(e, quotas, this.props.data)} />
                                </div>
                            </div>
                            <div className="d-h-start mb-4">
                                <p className="dsl-m12 mb-0 scorecard-label">Title</p>
                                <p className="dsl-b16 text-400 mb-0">{data.title}</p>
                            </div>
                            <div className="d-h-start mb-4">
                                <p className="dsl-m12 mb-0 scorecard-label">Frequency</p>
                                <p className="dsl-b16 mb-0">{scorecardType.value}</p>
                            </div>
                            <div className="d-h-start mb-4 w-100">
                                <p className="dsl-m12 mb-0 scorecard-label">Description</p>
                                <p className="dsl-b16 mb-0 w-70">{data.data.description}</p>
                            </div>
                        </div>
                    </div>
                    <div className="detail-list mt-3" data-cy="quotasList">
                        <div className="d-flex-1 align-items-start dsl-b18 bold mb-5">Goals</div>
                        <div className="section d-flex border-bottom pb-2">
                            <div className="d-flex-10">
                                <p className="dsl-m12 text-400 m-0">Goal</p>
                            </div>
                            <div className="d-none d-sm-flex d-flex-4 ps-3">
                                <p className="dsl-m12 text-400 m-0">Value type</p>
                            </div>
                            <div className="d-flex-4">
                                <p className="dsl-m12 text-400 m-0">Scale</p>
                            </div>
                            <div className="edit d-flex-1 d-h-end" />
                        </div>
                        <div className="section py-0">
                            {quotas.length > 0 ? quotas.map((quota, idx) => <Quota data={quota} key={quota.id} index={idx} />) : <p className="dsl-mb16 my-4">No Quotas attached</p>}
                        </div>
                    </div>
                    <Settings values={settings} stats={stats} />
                </div>
            </>
        );
    }
}

Detail.propTypes = {
    data: PropTypes.any,
    authors: PropTypes.array,
    departments: PropTypes.array,
    competencies: PropTypes.array,
    categories: PropTypes.array,
};

Detail.defaultProps = {
    data: {},
    authors: [],
    departments: [],
    competencies: [],
    categories: [],
};

export default Detail;
